import { css } from 'aphrodite';
import { Helper } from '../../../common/helpers/Helper';
import { AppStyles } from '../../../styles/AppTheme';
import { LayoutsItems } from '../LayoutsItems';
import React, { Fragment } from 'react';
import { Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';

export class LayoutsOrgPartner extends LayoutsItems {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/LayoutsOrgPatner.js